
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/types/gamification';
import { Sparkles } from 'lucide-react';

interface BadgesGridProps {
  badges: Badge[];
}

const BadgesGrid: React.FC<BadgesGridProps> = ({ badges }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {badges.map(badge => (
        <Card key={badge.id} className="overflow-hidden border border-purple-500/20 bg-black/20">
          <CardContent className="p-4">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 rounded-full bg-purple-900/30 flex items-center justify-center text-purple-400">
                {badge.icon === 'sparkles' ? (
                  <Sparkles className="h-6 w-6" />
                ) : (
                  <span className="text-2xl">{badge.icon}</span>
                )}
              </div>
              <div className="flex-1">
                <h3 className="font-semibold">{badge.name}</h3>
                <p className="text-sm text-gray-400">{badge.description}</p>
                <div className="mt-1 flex items-center justify-between">
                  <span className="text-xs text-gray-500">
                    {badge.dateEarned.toLocaleDateString()}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-purple-900/30 text-purple-400 capitalize">
                    {badge.rarity}
                  </span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default BadgesGrid;
